module.exports = __webpack_public_path__ + "static/banner-1-f446650e854c11ec83b92d6a673dc7c7.svg";